var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-form__row"},[_c('div',{staticClass:"c-form__submit"},[_c('button',{staticClass:"o-button o-button--wide",on:{"click":_vm.loginClicked}},[_vm._v(_vm._s(_vm.$t(_vm.i18n.label)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }